import { render, staticRenderFns } from "./AddAdvanced.vue?vue&type=template&id=61c04573&scoped=true&"
import script from "./AddAdvanced.vue?vue&type=script&lang=js&"
export * from "./AddAdvanced.vue?vue&type=script&lang=js&"
import style0 from "./AddAdvanced.vue?vue&type=style&index=0&id=61c04573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c04573",
  null
  
)

export default component.exports